import React, { ReactNode } from "react";
import classNames from "classnames";

type TabsProps = {
  ariaLabel?: string;
  children: ReactNode;
  className?: string;
};

const Tabs: React.FC<TabsProps> = ({
  ariaLabel,
  children,
  className,
  ...others
}) => (
  <>
    <nav
      className={classNames("tabs tabs-underline", className)}
      aria-label={ariaLabel}
      {...others}
    >
      {children}
    </nav>
    <style>{`
      .tabs-underline {
        box-shadow: inset 0 -1px 0 0 var(--color-light-grey);
      }
    `}</style>
  </>
);

export default Tabs;
